export default {"src":"/_next/static/media/black-room-names.7101010d.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};